import Modal from "../../../Modal/Modal";
import ButtonUI from "../../../UI/ButtonUI/ButtonUI";

export default function DeleteAddress({
    isModalOpen,
    closeModal,
    address,
    onDelete
}) {
    if (!isModalOpen) return null

    return <Modal onClose={closeModal}>
        <div className="delete-address">
            <div className="delete-address__top">
                <h3 className="delete-address__title">Удалить адрес</h3>
                <button className="delete-address__close" type="button" onClick={closeModal}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L10.0455 10.0454M10.0455 10.0454L1 19M10.0455 10.0454L19 1M10.0455 10.0454L19 19" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                </button>
            </div>

            <div className="delete-address__body">
                <span className="delete-address__text">Вы действительно хотите удалить адрес?</span>
                <span className="delete-address__address">{address.city}, {address.addressFields.street}</span>

                <div className="delete-address__group">
                    <ButtonUI text="Нет" theme="outline-rect" onClick={closeModal} />
                    <ButtonUI text="Да" theme="rect" onClick={onDelete} />
                </div>
            </div>
        </div>
    </Modal>
}